import React from "react";
import { Instagram, Mail, Phone, Globe } from "lucide-react";
import { useTranslation } from "react-i18next";
import logo from "../assets/logo-applaby.png";

const languages = [
	{ code: "es", label: "Español" },
	{ code: "en", label: "English" },
	{ code: "ca", label: "Català" },
];

export default function Footer() {
	const { t, i18n } = useTranslation();

	const changeLanguage = (langCode) => {
		i18n.changeLanguage(langCode);
		localStorage.setItem("language", langCode);
	};

	const currentLang = languages.find((l) => l.code === i18n.language) || languages[0];

	return (
		<footer className="bg-white text-gray-600">
			<div className="max-w-6xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-3 gap-8">
				{/* Logo + claim */}
				<div>
					<img src={logo} alt="Applaby" className="h-10 mb-4" />
					<p className="text-sm">{t("footer.claim")}</p>
				</div>

				{/* Menú */}
				<div className="flex flex-col gap-2 text-sm">
					<a
						href="#inicio"
						onClick={(e) => {
							e.preventDefault();
							document.querySelector("#inicio")?.scrollIntoView({
								behavior: "smooth",
							});
						}}
						className="hover:text-primary transition"
					>
						{t("footer.menu.home")}
					</a>
					<a
						href="#sectores"
						onClick={(e) => {
							e.preventDefault();
							document.querySelector("#sectores")?.scrollIntoView({
								behavior: "smooth",
							});
						}}
						className="hover:text-primary transition"
					>
						{t("footer.menu.sectors")}
					</a>
					<a
						href="#precios"
						onClick={(e) => {
							e.preventDefault();
							document.querySelector("#precios")?.scrollIntoView({
								behavior: "smooth",
							});
						}}
						className="hover:text-primary transition"
					>
						{t("footer.menu.pricing")}
					</a>
					<a href="/blog" className="hover:text-primary transition">
						{t("footer.menu.blog")}
					</a>
					<a
						href="/terminos"
						target="_blank"
						rel="noreferrer"
						className="hover:text-primary transition"
					>
						{t("footer.menu.terms")}
					</a>
					<a
						href="/politica-privacidad"
						target="_blank"
						rel="noreferrer"
						className="hover:text-primary transition"
					>
						{t("footer.menu.privacy")}
					</a>
				</div>

				{/* Contacto + redes */}
				<div className="flex flex-col gap-3 text-sm">
					<a
						href="mailto:info@applaby.com"
						className="flex items-center gap-2 hover:text-primary transition"
					>
						<Mail className="w-4 h-4" /> info@applaby.com
					</a>
					<a
						href="tel:+34608916357"
						className="flex items-center gap-2 hover:text-primary transition"
					>
						<Phone className="w-4 h-4" /> +34 608 916 357
					</a>
					<a
						href="https://www.instagram.com/applaby_es"
						target="_blank"
						rel="noreferrer"
						className="flex items-center gap-2 hover:text-primary transition"
					>
						<Instagram className="w-5 h-5" /> @applaby_es
					</a>
				</div>
			</div>

			{/* Idioma + Copyright */}
			<div className="border-t border-gray-200 mt-10 mb-6 pt-6">
				<div className="max-w-6xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
					<p className="text-xs text-gray-500">
						© {new Date().getFullYear()} Applaby. {t("footer.rights")}
					</p>

					{/* Selector d'idioma */}
					<div className="flex items-center gap-2">
						<Globe className="w-4 h-4 text-gray-400" />
						<div className="flex gap-1">
							{languages.map((lang) => (
								<button
									key={lang.code}
									onClick={() => changeLanguage(lang.code)}
									className={`px-2 py-1 text-xs rounded transition ${
										i18n.language === lang.code
											? "bg-primary text-white"
											: "bg-gray-100 text-gray-600 hover:bg-gray-200"
									}`}
									title={lang.label}
								>
									{lang.code.toUpperCase()}
								</button>
							))}
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
}
